import { useMemo } from 'react';

import {
  getTotalSumWithCurrency,
  updatePoolsWithPrizes,
} from '@/helpers/jackpot';
import { useGetCommonStore } from '@/store';

import { useExchangeAmount } from './useExchangeAmount';

export const useJackpotPools = () => {
  const useCommonStore = useGetCommonStore();
  const levels = useCommonStore.use.activeJackpot()?.levels;

  const { formatExchangedAmount, displayCurrency } = useExchangeAmount();

  const { pools, totalPrize } = useMemo(() => {
    if (!levels) {
      return { pools: [], totalPrize: 0 };
    }

    return {
      pools: updatePoolsWithPrizes(levels),
      totalPrize: getTotalSumWithCurrency(levels),
    };
  }, [levels]);

  const formattedTotalPrize = useMemo(
    () => formatExchangedAmount(totalPrize),
    [formatExchangedAmount, totalPrize]
  );

  return {
    pools,
    totalPrize,
    formattedTotalPrize,
    displayCurrency,
    hasData: pools.length > 0,
  };
};
